exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  font-family: 'Roboto', sans-serif;\n  color: #3f51b5;\n}\n\nmat-form-field {\n  width: 100%;\n}\n\n::ng-deep .linkarea .mat-input-placeholder {\n  color: #844E1B;\n}\n\n::ng-deep .linkarea.mat-focused .mat-input-placeholder {\n  color: #43a047;\n}\n\n::ng-deep .linkarea .mat-form-field-underline {\n  background-color: #844E1B;\n}\n\n.linkarea {\n  width: 100%;\n  /*color:#844E1B;*/\n  font-family: 'Roboto', sans-serif;\n  font-size: 16px;\n  font-weight: 300;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/image-link-dialog/image-link-dialog.component.css
// module id = ../../../../../src/app/image-link-dialog/image-link-dialog.component.css
// module chunks = main